import { AGE_GROUP_APPEAL, GENDER_TONE } from 'src/data/demographics';

const getAppealAgeTitle = (ageGroupAppeal) => {
  switch (ageGroupAppeal) {
    case AGE_GROUP_APPEAL.youngest:
      return 'Appealing to younger age groups';
    case AGE_GROUP_APPEAL.oldest:
      return 'Appealing to older age groups';
    case AGE_GROUP_APPEAL.middle:
      return 'Appealing to young and middle-age adults';
    case AGE_GROUP_APPEAL.none:
    case AGE_GROUP_APPEAL.neutral:
    default:
      return 'Appealing to all age groups';
  }
};

const getNoneAppealAgeTitle = (ageGroupAppeal) => {
  switch (ageGroupAppeal) {
    case AGE_GROUP_APPEAL.youngest:
      return 'Somewhat appealing to younger age groups';
    case AGE_GROUP_APPEAL.oldest:
      return 'Somewhat appealing to older age groups';
    case AGE_GROUP_APPEAL.middle:
      return 'Somewhat appealing to young and middle-age adults';
    case AGE_GROUP_APPEAL.none:
    case AGE_GROUP_APPEAL.neutral:
    default:
      return 'Somewhat appealing to all age groups';
  }
};

export const getAgeTitle = (score, noneAppeal, ageGroupAppeal) => {
  if (!score) {
    return 'Not appealing to any age group';
  }
  return noneAppeal
    ? getNoneAppealAgeTitle(ageGroupAppeal)
    : getAppealAgeTitle(ageGroupAppeal);
};

export const getGenderTitle = (genderTone) => {
  switch (genderTone) {
    case GENDER_TONE.feminine:
      return 'Female tone of voice';
    case GENDER_TONE.masculine:
      return 'Male tone of voice';
    case GENDER_TONE.neutral:
    default:
      return 'Gender-neutral tone of voice';
  }
};
